export type QStartQuery = {
  cttId: string | null;
  firstName: string | null;
  lastName: string | null;
  location: string | null;
  job: string | null;
  company: string | null;
  companyId: string | null;
  startOver: boolean;
};

/** Collapse whitespace left by `%20` or `+` in a query value. */
export function normalizeQueryValue(value: string | null | undefined): string | null {
  if (value == null) return null;
  const normalized = value.trim().replace(/\s+/g, " ");
  return normalized.length > 0 ? normalized : null;
}

function firstParam(params: URLSearchParams, names: string[]): string | null {
  const wanted = new Set(names.map((name) => name.toLowerCase()));
  for (const [key, raw] of params.entries()) {
    if (!wanted.has(key.toLowerCase())) continue;
    const value = normalizeQueryValue(raw);
    if (value) return value;
  }
  return null;
}

/** Read `/r` query values. Names are case-insensitive; `+` and `%20` are spaces. */
export function readQStartQuery(params: URLSearchParams): QStartQuery {
  const startOverRaw = firstParam(params, ["startOver"]);
  return {
    cttId: firstParam(params, ["cid", "ctt", "cttId"]),
    firstName: firstParam(params, ["firstName"]),
    lastName: firstParam(params, ["lastName"]),
    location: firstParam(params, ["location", "site"]),
    job: firstParam(params, ["job", "position", "jobDescription"]),
    company: firstParam(params, ["company"]),
    companyId: firstParam(params, ["companyId"]),
    startOver: startOverRaw === "1" || startOverRaw?.toLowerCase() === "true",
  };
}
